import { render, staticRenderFns } from "./TickerList.vue?vue&type=template&id=6a88256b&scoped=true&lang=html"
import script from "./TickerList.vue?vue&type=script&lang=js"
export * from "./TickerList.vue?vue&type=script&lang=js"
import style0 from "./TickerList.vue?vue&type=style&index=0&id=6a88256b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a88256b",
  null
  
)

export default component.exports